import PropTypes from 'prop-types'

export const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func
}

export const defaultProps = {}
